import React from 'react';
import { Box } from '@mui/material';

interface FieldWithModificationIndicatorProps {
  children: React.ReactNode;
  isModified: boolean;
  label: string;
}

// Feld mit Markierung für geänderte Felder - basiert auf MUI-Beispiel-Struktur
const FieldWithModificationIndicator = React.memo<FieldWithModificationIndicatorProps>(({ children, isModified, label }) => {
  return (
    <Box 
      className={isModified ? 'modified-field-container' : ''}
      sx={{ 
        // Styles für ALLE Felder - Orange wenn geändert, Dunkelgrau für normale Felder
        "& .MuiOutlinedInput-root": {
          backgroundColor: isModified ? "#fff8f0" : "white",
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: isModified ? "#ff6b35" : "#424242",
            borderWidth: isModified ? "2px" : "1px",
          },
          "&:hover": {
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: isModified ? "#e55a2b" : "#666666",
            },
          },
          "&.Mui-focused": {
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: isModified ? "#ff6b35" : "#424242",
              borderWidth: isModified ? "2px" : "2px",
            },
          },
          "& .MuiInputLabel-outlined": {
            color: isModified ? "#ff6b35" : "#424242",
            fontWeight: isModified ? "600" : "400",
            backgroundColor: isModified ? "#fff8f0" : "white",
            paddingLeft: "6px",
            paddingRight: "6px",
            "&.Mui-focused": {
              color: isModified ? "#ff6b35" : "#424242",
              fontWeight: isModified ? "600" : "500",
              backgroundColor: isModified ? "#fff8f0" : "white",
            },
          },
        },
        // Fallback für andere Label-Varianten
        "& .MuiInputLabel-root": {
          color: isModified ? "#ff6b35" : "#424242",
          fontWeight: isModified ? "600" : "400",
          backgroundColor: isModified ? "#fff8f0" : "white",
          paddingLeft: "6px",
          paddingRight: "6px",
          "&.Mui-focused": {
            color: isModified ? "#ff6b35" : "#424242",
            backgroundColor: isModified ? "#fff8f0" : "white",
          },
        },
      }}
    >
      {children}
    </Box>
  );
});

FieldWithModificationIndicator.displayName = 'FieldWithModificationIndicator';

export default FieldWithModificationIndicator;